import { type DocumentNode, gql } from '@apollo/client';

const updateViewFieldMutation: DocumentNode = gql`
  mutation update_view_field(
    $viewId: ID!
    $viewFieldId: ID!
    $fieldDefId: ID!
    $fieldType: String
    $fieldLabel: String
    $sequence: Int
  ) {
    updateViewField(
      viewId: $viewId
      viewFieldId: $viewFieldId
      fieldDefId: $fieldDefId
      fieldType: $fieldType
      fieldLabel: $fieldLabel
      sequence: $sequence
    ) {
      viewField {
        id
        view {
          id
        }
        fieldLabel
      }
    }
  }
`;

export default updateViewFieldMutation;
